import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            // Check if it's a 401 error with revoked token message
            if (
                error.status === 401 &&
                error.error &&
                (error.error.error === 'The provided token has been revoked!' ||
                    error.error.message === 'Failed to verify access token')
            ) {
                // Clear session storage
                sessionStorage.removeItem('shop_session');

                // Redirect to login page
                router.navigate(['/login']);
            }

            // Re-throw the error so other error handlers can still process it
            return throwError(() => error);
        })
    );
};
